module.exports = {"id":"202491","name":"Tom Carroll","rating":"73","photo":"./data/images/photos/4/202491.png","club":{"name":"Swansea City","logo":"./data/images/clubs/SwanseaCity.png"},"positions":["MC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TomCarroll0.json
// module id = 4162
// module chunks = 0